export default [
  {
    path: '/mission_center',
    component: () => import('@/views/page/mission_center.vue')
  }
]
